import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faApple,
    faGoogle,
    faMicrosoft,
    faFacebook,
    faInstagram,
    faYahoo,
    faXTwitter
} from '@fortawesome/free-brands-svg-icons';
import { 
    faBullhorn,
    faCartShopping,
    faCopy, 
    faComment, 
    faCircleCheck,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleExclamation,
    faCirclePlay,
    faCirclePlus,
    faCircleQuestion,
    faCircleXmark,
    faCommentDots,
    faEllipsisVertical,
    faEnvelope,
    faEnvelopeCircleCheck,
    faEye,
    faFile,
    faHeart,
    faHouse,
    faLock,
    faPaperPlane,
    faPen,
    faPhotoFilm,
    faShop,
    faSquare,
    faSquareCheck, //
    faGear, 
    faArrowUpFromBracket, 
    faRightFromBracket, 
    faMobileScreen, 
    faEnvelopeOpen, 
    faCalendarDays,
    faPenToSquare,
    faUser,
    faUserPlus,
    faUpload,
    faWallet
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faGoogle,
    faMicrosoft,
    faYahoo,
    faApple,
    faBullhorn,
    faCartShopping,
    faCopy, 
    faComment,
    faCircleCheck,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleExclamation,
    faCirclePlay,
    faCirclePlus,
    faCircleQuestion,
    faCircleXmark,
    faCommentDots,
    faEllipsisVertical,
    faEnvelope,
    faEnvelopeCircleCheck,
    faFacebook,
    faEye,
    faFile,
    faHeart,
    faHouse,
    faInstagram,
    faLock,
    faPaperPlane,
    faPen,
    faPhotoFilm,
    faSquare, 
    faSquareCheck, 
    faGear, 
    faArrowUpFromBracket, 
    faRightFromBracket, 
    faMobileScreen, 
    faEnvelopeOpen, 
    faCalendarDays,
    faPenToSquare,
    faShop,
    faUser,
    faUserPlus,
    faUpload,
    faWallet,
    faXTwitter
);